import {
  default as React,
  useContext,
  useEffect,
  useReducer,
  useState,
} from "react";
import Badge from "react-bootstrap/esm/Badge";
import Button from "react-bootstrap/esm/Button";
import Col from "react-bootstrap/esm/Col";
import ListGroup from "react-bootstrap/esm/ListGroup";
import Modal from "react-bootstrap/esm/Modal";
import Row from "react-bootstrap/esm/Row";
import { Helmet } from "react-helmet-async";
import QRCode from "react-qr-code";
import { useMediaQuery } from "react-responsive";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Store } from "../Store";
import CategoryList from "../components/CategoryList";
import FeaturesList from "../components/FeaturesList";
import MobileCartModal from "../components/MobileCartModal";
import ProductAra from "../components/ProductAra";
import ProductsList from "../components/ProductsList";
import ProductsListGrid from "../components/ProductsListGrid";
import SepeteEkleList from "../components/SepeteEkleList";
import TableDescription from "../components/TableDescription";
import TableExchange from "../components/TableExchange";
import TablesMobile from "../components/TablesMobile";
import useAxios from "../hooks/useAxios";
import useCompartments from "../hooks/useCompartments";
import useProductsAndCategories from "../hooks/useProductsAndCategories";
import useUsers from "../hooks/useUsers";
import { getError } from "../utils";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
        categories: action.payload.categories,
        products: action.payload.products,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default function CategoricOrderScreen() {
  const axios = useAxios();
  useUsers();
  const [{ loading }] = useReducer(reducer, {
    loading: false,
    error: "",
  });

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const {
    carts,
    table,
    mostUsedProducts,
    products,
    categories,
    allCategories,
    userInfo,
    categoryHistory,
  } = state;

  const compartments = state.compartments || [];
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const smallComputer = useMediaQuery({ query: "(max-width: 1350px)" });

  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const rootCategory = sp.get("rootCategory") || "";
  const navigate = useNavigate();
  const [selectedCompartment, setSelectedCompartment] = useState(null);
  const [showEnterDescription, setShowEnterDescription] = useState(false);
  const [tableCompartment, setTableCompartment] = useState(null);
  const [showCategories, setShowCategories] = useState(false);
  const [mostUsedProductsFiltered, setMostUsedProductsFiltered] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [tableCompartmentProducts, setTableCompartmentProducts] = useState([]);
  const [tableTemp, setTableTemp] = useState(table);
  const [tablePage, setTablePage] = useState(0);
  const [isGridView, setIsGridView] = useState(false);
  const [tableSelectedFromMain, setTableSelectedFromMain] = useState(false);
  const [queryByName, setQueryByName] = useState("");
  const [reportDate, setReportDate] = useState();
  const [reportDanger, setReportDanger] = useState(false);
  const [qrShow, setQrShow] = useState(false);
  const [show, setShow] = useState(false);
  const [descriptionTable, setDescriptionTable] = useState();
  const [customerName, setCustomerName] = useState("");

  const [features, setFeatures] = useState([]);
  const [feature, setFeature] = useState("");
  const [product, setProduct] = useState("");
  const [cartsOrdered, setCartsOrdered] = useState([]);
  const [tableCode, setTableCode] = useState("");
  const [showCart, setShowCart] = useState(false);

  const handleQrClose = () => setQrShow(false);

  const handleQrShow = (tableNum, qrshow = true) => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`/api/customer?tableNum=${tableNum}`);
        setTableCode(data.tableCode);
        if (qrshow) {
          setQrShow(true);
        }
      } catch (err) {
        toast.error(getError(err));
      }
    };
    fetchData();
  };

  const resetToHead = () => {
    setFeature("");
    setFeatures([]);
    setProduct("");
    setQueryByName("");
  };

  useEffect(() => {
    setTableTemp(table);
  }, [table]);

  useCompartments();

  const [loadingProductsAndCategories, , ,] = useProductsAndCategories();

  useEffect(() => {
    const mostUsedFiltered =
      tableCompartment &&
      tableCompartment.categories &&
      tableCompartment.categories.length > 0 &&
      tableCompartmentProducts.length > 0
        ? mostUsedProducts.filter((m) =>
            tableCompartmentProducts.includes(m._id)
          )
        : mostUsedProducts;

    setMostUsedProductsFiltered(mostUsedFiltered || []);
  }, [tableCompartment, tableCompartmentProducts, mostUsedProducts]);

  useEffect(() => {
    const founds = compartments
      .filter((c) => c.status)
      .filter((c) => tableTemp >= c.startNum && tableTemp <= c.endNum);
    if (founds.length > 0) {
      setTableCompartment(founds[0]);
      if (founds[0].categories && founds[0].categories.length > 0) {
        setTableCompartmentProducts(
          founds[0].categories
            .flatMap((c) => c.products)
            .filter((value, index, array) => array.indexOf(value) === index)
        );
      }
    }
  }, [tableTemp]);

  useEffect(() => {
    if (queryByName) {
      let queryProducts = isNaN(queryByName)
        ? products.filter((p) =>
            p.name.toLowerCase().includes(queryByName.toLowerCase())
          )
        : products.filter((p) => p.no === Number(queryByName));

      queryProducts =
        tableCompartment &&
        tableCompartment.categories &&
        tableCompartment.categories.length > 0 &&
        tableCompartmentProducts.length > 0
          ? queryProducts.filter((m) =>
              tableCompartmentProducts.includes(m._id)
            )
          : queryProducts;

      setFilteredProducts(queryProducts);
      setFilteredCategories([]);
    } else {
      if (rootCategory) {
        const rootCategories = allCategories.filter(
          (c) => c._id === rootCategory
        )[0].categories;
        const rootProducts = allCategories.filter(
          (c) => c._id === rootCategory
        )[0].products;
        if (rootCategories.length > 0) {
          setFilteredCategories(rootCategories);
          setFilteredProducts([]);
        } else if (rootProducts.length > 0) {
          setFilteredProducts(rootProducts);
          setFilteredCategories([]);
        }
      } else {
        if (
          showCategories ||
          !mostUsedProducts ||
          mostUsedProducts.length === 0
        ) {
          setFilteredCategories(
            tableCompartment &&
              tableCompartment.categories &&
              tableCompartment.categories.length > 0
              ? tableCompartment.categories
              : categories
          );
          setFilteredProducts([]);
          //setShowCategories(true);
        } else {
          setFilteredProducts(mostUsedProductsFiltered);
          setFilteredCategories([]);
        }
      }
    }
  }, [
    mostUsedProductsFiltered,
    queryByName,
    products,
    categories,
    tableCompartment,
    tableCompartmentProducts,
    rootCategory,
    showCategories,
    mostUsedProducts,
    allCategories,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`/api/categories/leafes/compartment`);

        ctxDispatch({
          type: "LEAF_CATEGORIES_UPDATED",
          payload: data || [],
        });
      } catch (err) {}
    };

    const leafCategories = localStorage.getItem("leafCategories")
      ? JSON.parse(localStorage.getItem("leafCategories"))
      : [];
    if (leafCategories.length === 0) {
      fetchData();
    }
  }, []);

  const fetchReportDate = async () => {
    try {
      const { data } = await axios.get(`/api/orders/reportdate`);
      setReportDate(new Date(data.reportDate));
      //setDontShowReportDate(data.waitNextDay);
      setReportDanger(data.danger);
    } catch (error) {
      toast(getError(error));
    }
  };

  useEffect(() => {
    fetchReportDate();
  }, []);

  useEffect(() => {
    const cartsOrders = carts.filter(
      (cart) =>
        cart && cart.cartItems.length > 0 && !cart.delivered && cart.alert
    );
    setCartsOrdered(cartsOrders);
  }, [carts]);

  useEffect(() => {
    cartsOrdered.forEach((c) => {
      c.cartItems.forEach((item) => {
        if (!item.delivered && item.alert && !item.alertPlayed) {
          var audio = new Audio("/ding.mp3");
          audio.play();
          ctxDispatch({
            type: "CARTITEM_SET_ALERT_PLAYED",
            payload: {
              tableNum: c.tableNum,
              itemCode: item.itemCode,
            },
          });
        }
      });
    });
  }, [cartsOrdered]);

  useEffect(() => {
    if (tableTemp && tableSelectedFromMain && !smallComputer) {
      ctxDispatch({
        type: "SELECT_TABLE",
        payload: tableTemp,
      });

      var elem = document.getElementById("tablePanel");
      elem.scrollTop =
        document.getElementById("tableButton" + tableTemp).offsetTop - 300;
      setTableSelectedFromMain(false);
    }
  }, [tableSelectedFromMain]);

  return (
    <div>
      <Helmet>
        <title>Sipariş Girişi</title>
      </Helmet>
      <Row>
        <Col className="text-start" md={6}>
          {!!tableTemp && (
            <ListGroup horizontal>
              <ListGroup.Item className="borderZero bg-dark">
                <Link
                  className="textDecorationNone"
                  onClick={() => {
                    setQueryByName("");
                    setTableTemp(0);
                    ctxDispatch({ type: "SELECT_TABLE", payload: 0 });
                  }}
                  to={``}
                >
                  <h5 className="bg-dark text-success">
                    <i className="fas fa-table"></i>
                  </h5>
                  {tableTemp > 0 && (
                    <Badge
                      bg="success bg-warning  "
                      className="cart-badge"
                      style={{
                        position: "absolute",
                        top: "1px",
                        right: "1px",
                      }}
                    >
                      {tableTemp}
                    </Badge>
                  )}
                </Link>
              </ListGroup.Item>
              <ListGroup.Item className="borderZero bg-dark">
                <Link
                  className="textDecorationNone"
                  onClick={() => {
                    handleQrShow(tableTemp, false);
                    setShowCart(true);
                  }}
                  to={`/category/order?rootCategory=${rootCategory || ""}`}
                >
                  <h5 className="bg-dark text-success displayInline">
                    <i className="fas fa-shopping-cart text-success"></i>
                  </h5>
                  {carts[tableTemp - 1].cartItems.length > 0 && (
                    <Badge
                      pill
                      bg="danger"
                      className="cart-badge"
                      style={{
                        position: "absolute",
                        top: "1px",
                        right: "1px",
                      }}
                    >
                      {carts[tableTemp - 1].cartItems.length}
                    </Badge>
                  )}
                </Link>
              </ListGroup.Item>

              <ListGroup.Item className="borderZero bg-dark">
                <Link
                  className="textDecorationNone"
                  onClick={() => {
                    handleQrShow(tableTemp);
                  }}
                  to={`/category/order?rootCategory=${rootCategory || ""}`}
                >
                  <h5 className="bg-dark text-success displayInline">
                    <i className="fas fa-qrcode"></i>
                  </h5>
                </Link>
              </ListGroup.Item>

              {carts[tableTemp - 1].cartItems.length > 0 && (
                <ListGroup.Item className="borderZero bg-dark">
                  <Link
                    to="#"
                    variant="secondary"
                    className={"p-2 text-success"}
                    onClick={() => {
                      setShow(true);
                    }}
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                    }}
                  >
                    <i className="fas fa-exchange-alt"></i>
                  </Link>
                </ListGroup.Item>
              )}
              {carts[tableTemp - 1].cartItems.length > 0 && (
                <ListGroup.Item className="borderZero bg-dark">
                  <Link
                    to="#"
                    className="textDecorationNone text-success"
                    onClick={() => {
                      setShowEnterDescription(true);
                      setDescriptionTable(tableTemp);
                    }}
                  >
                    <h5>
                      <i className="fa fa-file-text-o"></i>
                    </h5>
                  </Link>
                </ListGroup.Item>
              )}
              <ListGroup.Item className="borderZero bg-dark">
                <Link
                  to="/dailyReport"
                  className={
                    reportDanger
                      ? "textDecorationNone text-danger"
                      : "textDecorationNone text-success"
                  }
                >
                  <h5 className="bg-dark">
                    <i className="far fa-clock"></i>
                  </h5>
                </Link>
              </ListGroup.Item>
            </ListGroup>
          )}

          {!tableTemp && compartments && compartments.length > 1 && (
            <ListGroup horizontal>
              {reportDate &&
                (reportDanger ? (
                  <ListGroup.Item
                    key="reportDate"
                    className="borderZero bg-dark"
                    style={{ paddingRight: "0" }}
                  >
                    <Link to="/dailyReport">
                      <h5>
                        <i className="far fa-clock text-danger"></i>
                      </h5>
                    </Link>
                  </ListGroup.Item>
                ) : (
                  <ListGroup.Item
                    key="reportDate"
                    className="borderZero bg-dark"
                    style={{ paddingRight: "0" }}
                  >
                    <Link to="/dailyReport">
                      <h5>
                        <i className="far fa-clock"></i>
                      </h5>
                    </Link>
                  </ListGroup.Item>
                ))}

              <ListGroup.Item
                key={"tumu"}
                className="borderZero bg-dark"
                style={{ paddingRight: "0" }}
              >
                <Link
                  className="textDecorationNone"
                  to=""
                  onClick={() => {
                    setSelectedCompartment(null);
                  }}
                >
                  <h5 className="bg-dark">
                    <i className="fas fa-angle-right text-secondary"></i>
                    <span
                      className={
                        !selectedCompartment ? "text-primary" : "text-secondary"
                      }
                    >
                      Tümü
                    </span>
                  </h5>
                </Link>
              </ListGroup.Item>
              {compartments
                .filter((c) => c.status)
                .map((c) => (
                  <ListGroup.Item
                    key={c._id}
                    className="borderZero bg-dark"
                    style={{ paddingRight: "0" }}
                  >
                    <Link
                      className="textDecorationNone"
                      to=""
                      onClick={() => {
                        setSelectedCompartment(c);
                      }}
                    >
                      <h5 className="bg-dark">
                        <i className="fas fa-angle-right text-secondary"></i>
                        <span
                          className={
                            selectedCompartment &&
                            selectedCompartment._id === c._id
                              ? "text-primary"
                              : "text-secondary"
                          }
                        >
                          {c.name}
                        </span>
                      </h5>
                    </Link>
                  </ListGroup.Item>
                ))}
            </ListGroup>
          )}
        </Col>
      </Row>

      {!!tableTemp && (
        <Row>
          <Col>
            <ListGroup horizontal>
              {categoryHistory.map((x, i) => (
                <ListGroup.Item
                  key={x.category}
                  className="borderZero bg-dark"
                  style={{ paddingRight: "0" }}
                >
                  <Link
                    className="textDecorationNone"
                    onClick={() => {
                      setQueryByName("");
                      ctxDispatch({
                        type: "SELECT_TABLE",
                        payload: tableTemp,
                      });
                      setProduct("");
                      setFeature("");
                      setFeatures([]);
                    }}
                    to={`/category/order?rootCategory=${x.category}`}
                  >
                    <h5 className="bg-dark">
                      <i className="fas fa-angle-right text-secondary"></i>
                      {x.name === "" ? "Menü " : x.name + " "}
                    </h5>
                  </Link>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Col>
        </Row>
      )}

      <Row>
        {table ? (
          <div
            className={`border border-white bg-dark ${
              isTabletOrMobile
                ? "rounded "
                : "rounded-end heightOfPanelNoOverflow"
            }`}
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <ProductAra
              queryByName={queryByName}
              setQueryByName={setQueryByName}
              setProduct={setProduct}
              setFeature={setFeature}
              setFeatures={setFeatures}
              loading={loading}
              navigate={navigate}
              rootCategory={rootCategory}
              showCategories={showCategories}
              setShowCategories={setShowCategories}
              setIsGridView={setIsGridView}
              isGridView={isGridView}
              filteredCategories={categories}
            />
            {features.length > 1 && !feature ? (
              <FeaturesList
                features={features}
                product={product}
                setFeature={setFeature}
                setFeatures={setFeatures}
                setProduct={setProduct}
              />
            ) : (product && product.features.length === 0) ||
              (product && feature) ? (
              <SepeteEkleList
                tableNum={table}
                feature={feature}
                product={product}
                setFeature={setFeature}
                setFeatures={setFeatures}
                setProduct={setProduct}
                setQueryByName={setQueryByName}
              />
            ) : (filteredProducts && filteredProducts.length > 0) ||
              !filteredCategories ||
              filteredCategories.length === 0 ? (
              !isGridView ? (
                <ProductsList
                  products={filteredProducts}
                  setFeature={setFeature}
                  setFeatures={setFeatures}
                  setProduct={setProduct}
                  isTabletOrMobile={isTabletOrMobile}
                />
              ) : (
                <ProductsListGrid
                  products={filteredProducts}
                  setFeature={setFeature}
                  setFeatures={setFeatures}
                  setProduct={setProduct}
                  isTabletOrMobile={isTabletOrMobile}
                />
              )
            ) : filteredCategories && filteredCategories.length > 0 ? (
              <CategoryList
                resetToHead={resetToHead}
                categories={categories || []}
              />
            ) : (
              <></>
            )}
          </div>
        ) : (
          <Col>
            <TablesMobile
              setTableTemp={setTableTemp}
              tableTemp={tableTemp}
              selectedCompartment={selectedCompartment}
              compartments={compartments}
            ></TablesMobile>
          </Col>
        )}
      </Row>

      <TableExchange
        carts={carts}
        show={show}
        setShow={setShow}
        changeThisTableNum={tableTemp}
      />

      <Modal show={qrShow} onHide={handleQrClose}>
        <Modal.Header closeButton>
          <Modal.Title>Musteri bu karekod ile siparis verebilir.</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="p-3">
            <QRCode
              size={256}
              className="qrcode"
              value={
                `${window.location.origin}/qrmenu?tableCode=` +
                tableCode +
                "&code=" +
                userInfo.membership.businessOwner
              }
              viewBox={`0 0 256 256`}
            />
            <p>
              Masa Kodu:
              {`${window.location.origin}/qrmenu?tableCode=` +
                tableCode +
                "&code=" +
                userInfo.membership.businessOwner}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleQrClose}>
            Kapat
          </Button>
        </Modal.Footer>
      </Modal>
      <MobileCartModal
        cartShow={showCart}
        setCartShow={setShowCart}
        customerName={customerName}
        setCustomerName={setCustomerName}
        tableTemp={tableTemp}
        tableCode={tableCode}
      />

      {showEnterDescription && (
        <TableDescription
          showEnterDescription={showEnterDescription}
          setShowEnterDescription={setShowEnterDescription}
          tableNum={tableTemp}
          alertTimePeriod={carts[tableTemp - 1]?.alertTimePeriod}
          onBusinessUser={carts[tableTemp - 1]?.onBusinessUser}
          tableType={carts[tableTemp - 1]?.tableType}
          alertOn={carts[tableTemp - 1]?.alertOn ?? true}
          description={carts[tableTemp - 1]?.description}
        />
      )}
    </div>
  );
}
